(function () {
    "use strict";

    var __ = function (s) {
        var args = arguments;
        if (typeof window.__ === "function") return window.__.apply(null, args);
        return String(s).replace(/\{(\d)\}/g, function (m, n) { return args[+n + 1] != null ? args[+n + 1] : m; });
    };

    var ROOT_SELECTOR = ".shkcamp";
    var OFFER_SELECTOR = "[data-shkcamp-offer]";
    var API_BASE = "/api/store/";
    var ACTION_DETAILS = new WeakMap();
    var PAINTED = new Map();
    var ACTION_ROOTS = new WeakSet();

    // Discount source adapter.
    // The Add Product form will receive dedicated discount fields; the final field list arrives in a
    // separate task. Until then the banner reads the promotion from the live Store row: an explicit
    // discount field when one is present, otherwise the list/current price pair the store cards and the
    // item page already use. When the final names are delivered, update DISCOUNT_FIELDS only.
    //
    // Convention: product_price is the amount the customer pays (it is what the cart charges today), so a
    // percent or amount field describes how far the current price sits below the original one.
    var DISCOUNT_FIELDS = {
        percent: ["product_discount_percent", "product_discount_rate", "discount_percent", "discount_rate"],
        amount: ["product_discount_amount", "discount_amount"],
        startsAt: ["product_discount_start", "discount_start", "discount_start_date"],
        endsAt: ["product_discount_end", "discount_end", "discount_end_date"],
        active: ["product_discount_active", "discount_active"]
    };

    function firstField(product, names) {
        for (var i = 0; i < names.length; i += 1) {
            var value = product[names[i]];
            if (value !== undefined && value !== null && value !== "") return value;
        }
        return null;
    }

    function cents(value) {
        if (typeof value !== "number" && (typeof value !== "string" || !/^\d+(?:\.\d+)?$/.test(value.trim()))) return null;
        var number = Number(value);
        var result = Math.round((number + Number.EPSILON) * 100);
        return Number.isFinite(number) && number > 0 && Number.isSafeInteger(result) && result > 0 ? result : null;
    }

    function parseStoreJson(input) {
        if (typeof input !== "string") return input;
        try { return JSON.parse(input); } catch (originalError) {
            var quoted = false;
            var escaped = false;
            var repaired = "";
            for (var i = 0; i < input.length; i += 1) {
                var character = input.charAt(i);
                if (quoted && character.charCodeAt(0) < 32) {
                    repaired += "\\u" + character.charCodeAt(0).toString(16).padStart(4, "0");
                    escaped = false;
                    continue;
                }
                if (character === '"' && !escaped) quoted = !quoted;
                repaired += character;
                escaped = character === "\\" && !escaped;
            }
            try { return JSON.parse(repaired); } catch (_ignored) { throw originalError; }
        }
    }

    // The header currency selector stores the visitor's choice in the local1 App Connect store; the store
    // cards and the item page convert with the same pair, so the banner follows them and falls back to USD.
    function siteCurrency() {
        var fallback = { code: "USD", rate: 1 };
        try {
            if (typeof window.dmx === "undefined" || typeof window.dmx.parse !== "function") return fallback;
            var code = String(window.dmx.parse("local1.data.currencyName") || "").trim().toUpperCase();
            var rate = Number(window.dmx.parse("local1.data.currency_exchange_rate"));
            if (!/^[A-Z]{3}$/.test(code) || !Number.isFinite(rate) || rate <= 0) return fallback;
            return { code: code, rate: rate };
        } catch (_ignored) {
            return fallback;
        }
    }

    function money(value, currency) {
        var shown = siteCurrency();
        var amount = currency === shown.code ? value : value * shown.rate;
        var rounded = Math.round(amount * 100) / 100;
        if (typeof window.sharkMoney === "function") return window.sharkMoney(rounded, shown.code);
        return new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: shown.code,
            currencyDisplay: "narrowSymbol",
            minimumFractionDigits: Number.isInteger(rounded) ? 0 : 2,
            maximumFractionDigits: 2
        }).format(rounded);
    }

    function discountWindowOpen(product) {
        var active = firstField(product, DISCOUNT_FIELDS.active);
        if (active !== null && [0, "0", false, "false"].includes(active)) return false;
        var now = Date.now();
        var starts = firstField(product, DISCOUNT_FIELDS.startsAt);
        var ends = firstField(product, DISCOUNT_FIELDS.endsAt);
        if (starts !== null) {
            var startMs = Date.parse(starts);
            if (Number.isFinite(startMs) && startMs > now) return false;
        }
        if (ends !== null) {
            var endMs = Date.parse(ends);
            if (Number.isFinite(endMs) && endMs < now) return false;
        }
        return true;
    }

    // Returns {original, current, percent} in cents, or null when the product carries no live promotion.
    function readDiscount(product, current) {
        if (!discountWindowOpen(product)) return null;
        var percentField = Number(firstField(product, DISCOUNT_FIELDS.percent));
        if (Number.isFinite(percentField) && percentField > 0 && percentField < 100) {
            return { original: Math.round(current / (1 - percentField / 100)), current: current, percent: Math.round(percentField) };
        }
        var amount = cents(firstField(product, DISCOUNT_FIELDS.amount));
        if (amount !== null) {
            var originalFromAmount = current + amount;
            return { original: originalFromAmount, current: current, percent: Math.round((amount / originalFromAmount) * 100) };
        }
        var list = cents(product.product_list_price);
        if (list !== null && list > current) {
            return { original: list, current: current, percent: Math.round((1 - current / list) * 100) };
        }
        return null;
    }

    function resolveOffer(product) {
        var current = cents(product && product.product_price);
        var currency = String(product && (product.currency || "USD") || "").trim().toUpperCase();
        if (current === null || !/^[A-Z]{3}$/.test(currency)) throw new Error("Campaign price or currency is unavailable.");
        var base = { currency: currency, storePrice: current / 100 };
        var discount = readDiscount(product, current);
        if (discount && discount.percent > 0) {
            return Object.assign({}, base, { mode: "live", original: discount.original / 100, current: current / 100, percent: discount.percent });
        }
        return Object.assign({}, base, { mode: "current", original: null, current: current / 100, percent: null });
    }

    function field(host, name) { return host.querySelector("[data-shkcamp-" + name + "]"); }
    function show(host, name, value) {
        var target = field(host, name);
        if (!target) return;
        target.textContent = value == null ? "" : String(value);
        target.hidden = value == null;
    }

    function reset(host, mode, status) {
        host.dataset.shkcampMode = mode;
        show(host, "status-line", status);
        show(host, "original", null);
        show(host, "current", null);
        var discount = field(host, "discount");
        if (discount) discount.hidden = true;
        show(host, "percent-value", null);
    }

    function paint(host, offer, status) {
        PAINTED.set(host, { offer: offer, status: status });
        reset(host, offer.mode, status);
        show(host, "current", money(offer.current, offer.currency));
        if (offer.percent !== null) {
            show(host, "original", money(offer.original, offer.currency));
            show(host, "percent-value", offer.percent);
            var discount = field(host, "discount");
            if (discount) discount.hidden = false;
        }
    }

    var ACTION_SELECTOR = "[data-shkcamp-buy],[data-shkcamp-add]";

    function actionsFor(host) {
        var purchase = host.closest(".shkcamp-purchase");
        return purchase ? Array.prototype.slice.call(purchase.querySelectorAll(ACTION_SELECTOR)) : [];
    }

    function disableAction(host) {
        actionsFor(host).forEach(function (action) {
            ACTION_DETAILS.delete(action);
            action.disabled = true;
            action.setAttribute("aria-disabled", "true");
        });
    }

    function prepareAction(host, product, offer) {
        actionsFor(host).forEach(function (action) {
            prepareOne(action, host, product, offer);
        });
    }

    function prepareOne(action, host, product, offer) {
        ACTION_DETAILS.set(action, Object.freeze({
            action: action.hasAttribute("data-shkcamp-add") ? "add-to-cart" : "checkout",
            source: "home-campaign-banner",
            routeContext: "home",
            productId: String(product.product_id),
            designId: String(product.design_id),
            sku: String(product.product_code),
            productType: "guitar",
            model: String(host.dataset.shkcampName),
            price: offer.storePrice,
            currency: offer.currency,
            priceAvailable: true,
            campaignMode: offer.mode,
            selections: {}
        }));
        action.disabled = false;
        action.setAttribute("aria-disabled", "false");
    }

    function apiUrl(root, search) {
        var raw = root.dataset.shkcampApiBase || API_BASE;
        var base = new URL(raw, globalThis.location && globalThis.location.href || "https://sharkguitars.com/");
        if (!/^https?:$/.test(base.protocol) || base.username || base.password || base.search || base.hash) throw new Error("Invalid public Store API base URL.");
        if (!base.pathname.endsWith("/")) base.pathname += "/";
        var url = new URL("guitarDataPaged", base);
        var params = { search: search, input_store: "1", sort_order: "", body_type_ids: "", headstock_ids: "", back_wood_ids: "", neck_wood_ids: "", limit: "1" };
        Object.keys(params).forEach(function (key) { url.searchParams.set(key, params[key]); });
        return url.href;
    }

    function assertIdentity(product, host) {
        if (!product || product.product_code !== host.dataset.shkcampSku || product.product_name !== host.dataset.shkcampName || Number(product.product_id) !== Number(host.dataset.shkcampProductId) || Number(product.design_id) !== Number(host.dataset.shkcampDesignId) || ![1, "1"].includes(product.product_status)) {
            throw new Error("Campaign product identity or publication state is unavailable.");
        }
        return product;
    }

    async function fetchProduct(root, host, options) {
        var controller = new AbortController();
        var timeoutMs = Number(options.timeoutMs) > 0 ? Number(options.timeoutMs) : 15000;
        var timer = setTimeout(function () { controller.abort(); }, timeoutMs);
        try {
            var fetchImpl = options.fetchImpl || globalThis.fetch;
            if (typeof fetchImpl !== "function") throw new Error("Fetch is unavailable.");
            var response = await fetchImpl(apiUrl(root, host.dataset.shkcampName), { credentials: "omit", cache: "no-store", signal: controller.signal });
            if (!response.ok || !/application\/json/i.test(response.headers.get("content-type") || "")) throw new Error("Campaign publication read failed.");
            var payload = parseStoreJson(await response.text());
            var envelope = payload && payload.queryStoreProducts;
            if (!envelope || !Array.isArray(envelope.data) || envelope.data.length < 1) throw new Error("Campaign publication search is missing.");
            var sku = host.dataset.shkcampSku;
            var match = envelope.data.filter(function (row) { return row && row.product_code === sku; })[0] || envelope.data[0];
            return assertIdentity(match, host);
        } finally {
            clearTimeout(timer);
        }
    }

    // Host integration, mirroring the store card's two commerce buttons. BUY NOW adds the guitar through
    // srvHomeQuickAddToCart and continues to the cart, or goes straight to the cart when the guitar is already in it
    // (addProductToCart toggles an existing row off); ADD TO CART uses the layout's srvAddProductToCart,
    // which refreshes the cart badge and shows the "Cart updated" notice. An anonymous visitor parks the
    // product in cartSession and is sent to login, where the layout's cartFlow adds it after sign-in.
    // srvHomeQuickAddToCart is declared in the page partial, so App Connect registers it under the layout's
    // dmx-view (id view1) and a bare name resolves to undefined; the layout's own components take no prefix.
    function commerceAction(root, detail) {
        if (typeof window.dmx === "undefined" || typeof window.dmx.parse !== "function") return false;
        var productId = Number(detail.productId);
        var designId = Number(detail.designId);
        if (!Number.isInteger(productId) || !Number.isInteger(designId)) return false;
        var userId = Number(window.dmx.parse("srvUserInfo.data.userInfo.user_id"));
        if (Number.isInteger(userId) && userId > 0) {
            if (detail.action !== "add-to-cart" && Number(window.dmx.parse("srvCartData.data.cartData.query.where('product_id', " + productId + ", '==').count()")) > 0) {
                globalThis.location.assign(root.dataset.shkcampCartHref || "/cart");
                return true;
            }
            var connect = detail.action === "add-to-cart" ? "srvAddProductToCart" : "view1.srvHomeQuickAddToCart";
            window.dmx.parse(connect + ".load({user_id: " + userId + ", product_id: " + productId + ", design_id: " + designId + "})");
            return true;
        }
        window.dmx.parse("cartSession.set('productId', " + productId + ")");
        window.dmx.parse("cartSession.set('designId', " + designId + ")");
        globalThis.location.assign(root.dataset.shkcampLoginHref || "/account/login");
        return true;
    }

    function bindActions(root) {
        if (ACTION_ROOTS.has(root)) return;
        ACTION_ROOTS.add(root);
        root.addEventListener("click", function (event) {
            var action = event.target.closest && event.target.closest(ACTION_SELECTOR);
            if (!action || !root.contains(action) || action.disabled) return;
            var detail = ACTION_DETAILS.get(action);
            if (!detail) return;
            var eventName = detail.action === "add-to-cart" ? "shark:add-to-cart" : "shark:quick-checkout";
            var accepted = action.dispatchEvent(new CustomEvent(eventName, { bubbles: true, cancelable: true, detail: Object.assign({}, detail) }));
            var liveStatus = root.querySelector("[data-shkcamp-live-status]");
            if (!accepted) {
                if (liveStatus) liveStatus.textContent = __("Commerce action handled by the store integration.");
                return;
            }
            if (commerceAction(root, detail)) {
                if (liveStatus) liveStatus.textContent = detail.action === "add-to-cart" ? __("Adding {0}.", detail.model) : __("Preparing checkout for {0}.", detail.model);
                return;
            }
            if (liveStatus) liveStatus.textContent = __("Opening the product page for {0}.", detail.model);
            var href = action.dataset.shkcampItemHref;
            if (href) globalThis.location.assign(href);
        });
    }

    async function refreshRoot(root, options) {
        bindActions(root);
        var hosts = Array.prototype.slice.call(root.querySelectorAll(OFFER_SELECTOR));
        return Promise.allSettled(hosts.map(async function (host) {
            disableAction(host);
            reset(host, "pending", __("Checking current price…"));
            host.setAttribute("aria-busy", "true");
            try {
                var product = await fetchProduct(root, host, options || {});
                var offer = resolveOffer(product);
                var status = offer.mode === "current" ? __("CURRENT STORE PRICE") : null;
                paint(host, offer, status);
                prepareAction(host, product, offer);
                return offer;
            } catch (error) {
                PAINTED.delete(host);
                reset(host, "error", __("See the product page for current pricing."));
                disableAction(host);
                throw error;
            } finally {
                host.setAttribute("aria-busy", "false");
            }
        }));
    }

    function rootsFrom(target) {
        var scope = target || document;
        if (scope.matches && scope.matches(ROOT_SELECTOR)) return [scope];
        return Array.prototype.slice.call(scope.querySelectorAll ? scope.querySelectorAll(ROOT_SELECTOR) : []);
    }

    function refresh(target, options) {
        return Promise.allSettled(rootsFrom(target).map(function (root) { return refreshRoot(root, options || {}); }));
    }

    function mount(target, options) { return refresh(target, options); }

    // A first visit can paint before the header writes the visitor's currency into local1, so prices are
    // painted again whenever local1's currency changes once App Connect is running.
    function repaint() {
        PAINTED.forEach(function (painted, host) {
            if (host.isConnected) paint(host, painted.offer, painted.status);
            else PAINTED.delete(host);
        });
    }

    function watchCurrency(attempt) {
        if (window.dmx && window.dmx.app && typeof window.dmx.app.$watch === "function") {
            window.dmx.app.$watch("local1.data.currencyName + '|' + local1.data.currency_exchange_rate", repaint);
            return;
        }
        if (attempt < 300) setTimeout(function () { watchCurrency(attempt + 1); }, 100);
    }

    watchCurrency(0);

    window.__shark_homeCampaignBanner = Object.freeze({ mount: mount, refresh: refresh, resolveOffer: resolveOffer, discountFields: DISCOUNT_FIELDS });
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { mount(document); }, { once: true });
    else mount(document);
})();
